import React, { useMemo, useState } from "react";
import "./PrivateOfficeSection13.scss";
import { useMediaQuery } from "react-responsive";

type FAQItem = {
  question: string;
  desktopAnswer: string;
  mobileAnswer?: string;
};

type CardProps = {
  question: string;
  answer: string;
  index: number;
  selectedIndex: number;
  onToggle: (index: number) => void;
};

const FAQ_ITEMS: FAQItem[] = [
  {
    question: "운영 시간은 어떻게 되나요?",
    desktopAnswer: `고객센터 운영 시간은 평일 오전 09~19시 이며, 사무실 이용은 24시간 자유롭게 이용 가능합니다.`,
  },
  {
    question: "회의실 이용 방법과 이용 가능 시간이 어떻게 되나요?",
    desktopAnswer:
      "월 5회, 일 최대 2시간 이용 가능합니다. 회의실 이용 방법은 지점 매니저에게 문의 부탁드립니다.",
  },
  {
    question: "계약 연장은 어떻게 하면 될까요?",
    desktopAnswer:
      "계약 연장의 경우 지점 매니저에게 계약 종료 2주 전까지 연장 의사를 말씀해주세요.",
  },
  {
    question: "계약 종료는 어떻게 하면 될까요?",
    desktopAnswer:
      "계약 종료의 경우 지점 매니저에게 계약 종료 2주 전까지 종료 의사를 말씀해주세요. 이후 사업자 주소 변경되면 보증금 반환해드립니다.",
  },
  {
    question: "보증금이 있나요?",
    desktopAnswer: `월 사용료 1개월 금액으로 보증금 책정됩니다. 계약 종료 후 사업자 주소 변경 확인되면 보증금을 반환해드립니다.`,
  },
  {
    question: "OA 기기 이용이 가능한가요?",
    desktopAnswer: `최신형 복합기를 이용하실 수 있으며, 프린트/복사/스캔/팩스 기능을 사용하실 수 있습니다.`,
  },
];

const Card = ({
  question,
  answer,
  index,
  selectedIndex,
  onToggle,
}: CardProps) => {
  const isActive = useMemo(
    () => index === selectedIndex,
    [index, selectedIndex]
  );

  return (
    <div
      className={`private-office-section13__card ${isActive ? "is-active" : ""}`}
      onClick={() => onToggle(index)}
    >
      <div className="private-office-section13__card-head">
        <p className="private-office-section13__card-title">{question}</p>
        <div
          className={
            isActive
              ? "private-office-section13__icon--collapse"
              : "private-office-section13__icon--expand"
          }
        />
      </div>
      <div
        className="private-office-section13__card-body"
        style={{ maxHeight: isActive ? 300 + "px" : 0 }}
      >
        <div>{answer}</div>
      </div>
    </div>
  );
};

const PrivateOfficeSection13 = () => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const isMobile = useMediaQuery({
    query: "(max-width: 1200px)",
  });

  const handleCardClick = (index: number) => {
    setSelectedIndex(index === selectedIndex ? -1 : index);
  };

  return (
    <section className="section private-office-section13" id="private-office-section13">
      <div className="section-inner private-office-section13__inner">
        <div className="section-header private-office-section13__header">
          자주 묻는 질문
        </div>
        <div className="private-office-section13__content">
          <div className="private-office-section13__card-list">
            {FAQ_ITEMS.map((item, index) => (
              <Card
                key={item.question}
                index={index}
                selectedIndex={selectedIndex}
                onToggle={handleCardClick}
                question={item.question}
                answer={
                  isMobile
                    ? item.mobileAnswer ?? item.desktopAnswer
                    : item.desktopAnswer
                }
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivateOfficeSection13;
